import React, { Component } from "react";
import { Subscribe } from "unstated";
import { withTranslation } from "react-i18next";

import StateContainer from "../../state/StateContainer";
import SliderCheckbox from "../SliderCheckbox/SliderCheckbox";
import InputRange from "react-input-range";

import FilterButton from "../Buttons/FilterButton/FIlterButton";
import DisplayWrapper from "../DisplayWrapper/DisplayWrapper";

import labelHelper from "../../utils/helpers/labelHelper";

import "react-input-range/lib/css/index.css";
import "./HotspotFilters.css";

class HotspotFilters extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dropdown: false,
      priceValues: {
        min: 0,
        max: 10000,
      },
      quadratureValues: {
        min: 0,
        max: 1400,
      },
    };
    
    window.addEventListener("setupDefaultState", (event) => {
      this.setDefaultFilterValues(event);
    });
  }

  /**
   * Sets default filter values.
   * @param event 
   */
  setDefaultFilterValues(event) {
    this.setState({
      priceValues: event.detail.priceValues,
      quadratureValues: event.detail.quadratureValues
    })
  }

  render() {
    const { t } = this.props;

    return (
      <React.Fragment>
            <div className="filter-container">
              <h3 className={"filter-title"}>
                <span>{t("FILTER").toUpperCase()}</span>{" "}
                {t("ACCOMMODATIONS").toUpperCase()}
              </h3>
              <div className="filter-row-checkbox">
                <DisplayWrapper
                  stayInDom={true}
                  displayParameter="isTerraceFilterVisibility"
                >
                  <SliderCheckbox
                    filterName={"terrace"}
                    label={
                      this.props.unstated.state.terraceFilterLabel !== "" ? 
                        this.props.unstated.state.terraceFilterLabel : t("TERRACE").toUpperCase()
                    }
                  />
                </DisplayWrapper>

                <DisplayWrapper
                  stayInDom={true}
                  displayParameter="isBalconFilterShown"
                >
                  <SliderCheckbox
                   filterName={"balcony"} 
                   label={this.props.unstated.state.balconyFilterLabel !== "" ? 
                      this.props.unstated.state.balconyFilterLabel : t("BALCONY").toUpperCase()
                   } />
                </DisplayWrapper>
                <DisplayWrapper
                  stayInDom={true}
                  displayParameter="isGalleryFilterShown"
                >
                  <SliderCheckbox 
                    filterName={"gallery"} 
                    label={this.props.unstated.state.galleryFilterLabel !== "" ? 
                      this.props.unstated.state.galleryFilterLabel : t("GALLERY").toUpperCase()
                    } 
                  />
                </DisplayWrapper>
                <DisplayWrapper
                  stayInDom={true}
                  displayParameter="isParkingFilterVisibility"
                >
                  <SliderCheckbox 
                    filterName={"parking"} 
                    label={this.props.unstated.state.parkingFilterLabel !== "" ? 
                      this.props.unstated.state.parkingFilterLabel : t("PARKING").toUpperCase()
                    } 
                  />
                </DisplayWrapper>
                <DisplayWrapper
                  stayInDom={true}
                  displayParameter="isGarageFilterShown"
                >
                  <SliderCheckbox 
                    filterName={"garage"} 
                    label={this.props.unstated.state.garageFilterLabel !== "" ? 
                      this.props.unstated.state.garageFilterLabel : t("GARAGE").toUpperCase()
                    } 
                  />
                </DisplayWrapper>

                <DisplayWrapper
                  stayInDom={true}
                  displayParameter="isGardenFilterVisibility"
                >
                  <SliderCheckbox 
                    filterName={"garden"} 
                    label={this.props.unstated.state.gardenFilterLabel !== "" ? 
                      this.props.unstated.state.gardenFilterLabel : t("GARDEN").toUpperCase()
                    } 
                  />
                </DisplayWrapper>
                <DisplayWrapper
                  stayInDom={true}
                  displayParameter="isDuplexFilterShown"
                >
                  <SliderCheckbox 
                    filterName={"duplex"} 
                    label={this.props.unstated.state.duplexFilterLabel !== "" ? 
                      this.props.unstated.state.duplexFilterLabel : t("DUPLEX").toUpperCase()
                    } 
                  />
                </DisplayWrapper>
              </div>

              
              <DisplayWrapper
                displayParameter="isPricingFilterShown"
                stayInDom={true}
                >
                <div className="filter-row">
                  <p className="range-label">{this.props.unstated.state.pricingFilterCurrency || 'EUR'}</p>
                  <InputRange
                    minValue={this.props.unstated.state.priceValues[0]}
                    maxValue={this.props.unstated.state.priceValues[1]}
                    formatLabel={value => labelHelper.formatPrice(value)}

                    value={this.state.priceValues}
                    onChange={(value) => {
                      this.setState({ priceValues: value })
                      this.props.unstated.setPriceFilter(value);

                      const event = new CustomEvent("sceneNeedsRender");
                      let canvas = document.getElementById("full-screenable-node");
                      canvas.dispatchEvent(event);
                    }}
                    onChangeComplete={(value) => {
                      const event = new CustomEvent("sceneNeedsRender");
                      let canvas = document.getElementById("full-screenable-node");
                      canvas.dispatchEvent(event);
                    }}
                    style={{ backgroundColor: this.props.unstated.state.menuColor }}
                  />
                </div>
              </DisplayWrapper>

              <div className="filter-row">
                <p className="range-label range-label-big">㎡</p>

                <InputRange
                  minValue={this.props.unstated.state.quadratureValues[0]}
                  maxValue={this.props.unstated.state.quadratureValues[1]}

                  value={this.state.quadratureValues}
                  onChange={(value) => {
                    this.setState({ quadratureValues: value })
                    this.props.unstated.setQuadratureFilter(value);

                    const event = new CustomEvent("sceneNeedsRender");
                    let canvas = document.getElementById(
                      "full-screenable-node"
                    );
                    canvas.dispatchEvent(event);
                  }}
                  onChangeComplete={(value) => {
                    const event = new CustomEvent("sceneNeedsRender");
                    let canvas = document.getElementById(
                      "full-screenable-node"
                    );
                    canvas.dispatchEvent(event);
                  }}
                />
              </div>

              <div className="type-container">
                <h4>{t("TYPE").toUpperCase()}</h4>
              </div>
              <div className="filter-row">
                {this.props.unstated.state.availableFilters?.map(filter => {
                  return (
                    <FilterButton
                      key={filter}
                      buttonFilter={filter}
                      buttonClass={`type-filter`}
                    />
                  );
                })}
              </div>
            </div>
      </React.Fragment>
    );
  }
}

const HotspotFiltersWithUnstated = (props) => {
  return (
    <Subscribe to={[StateContainer]}>
      {unstated => <HotspotFilters {...props} unstated={unstated}/>}
    </Subscribe>
  )
}

export default withTranslation()(HotspotFiltersWithUnstated);
